import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'
import type { CreateInvitationPayload, UpdateInvitationPayload, UpdateUserRolesPayload } from '~/types/licence-users'

const queries = {
  getUserDetails: {
    queryFn: () => useApi().licenceUsers.getUserDetails(),
    queryKey: () => ['licenceUserDetails']
  },
  getRoles: {
    queryFn: () => useApi().licenceUsers.getRoles(),
    queryKey: () => ['licenceRoles']
  }
} as const

const mutations = {
  createInvitation: {
    request: (payload: CreateInvitationPayload) => useApi().licenceUsers.createInvitation(payload),
    cacheKey: () => ['licenceUserDetails']
  },
  updateUserRoles: {
    request: ({ userId, ...payload }: { userId: number } & UpdateUserRolesPayload) =>
      useApi().licenceUsers.updateUserRoles(userId, payload),
    cacheKey: () => ['licenceUserDetails']
  },
  updateInvitation: {
    request: ({ invitationId, ...payload }: { invitationId: number } & UpdateInvitationPayload) =>
      useApi().licenceUsers.updateInvitation(invitationId, payload),
    cacheKey: () => ['licenceUserDetails']
  },
  removeUser: {
    request: ({ userId }: { userId: number }) => useApi().licenceUsers.updateUserRoles(userId, { role_ids: [] }),
    cacheKey: () => ['licenceUserDetails']
  }
} as const

export type LicenceUsersModelService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): LicenceUsersModelService =>
  defineService(authArgs, {
    queries,
    mutations
  })
